import * as React from 'react';
import { IAsidePanelHeaderProps } from './types';
import './_AsidePanelHeader.scss';
import { CLASS_ASIDE_PANEL_HEADER } from './constants';
import { AsidePanelTabsHOC } from '../../hocs/AsidePanelTabsHOC/AsidePanelTabsHOC';
import { AsidePanelCloseHOC } from '../../hocs/AsidePanelCloseHOC/AsidePanelCloseHOC';
import { AsidePanelClButtonHOC } from '../../hocs/AsidePanelClButtonHOC/AsidePanelClButtonHOC';
import { AsidePanelTitle } from '../AsidePanelTitle/AsidePanelTitle';
import { Button, Icon, Loader } from 'kui';
import { AsidePanelTitleAction } from '../AsidePanelTitleAction/AsidePanelTitleAction';
import { AsidePanelContext } from '../AsidePanel/constants';
import { AnalyzeRender } from '../../../../helpers/memoizeHelper';
import { root } from '../../../../../../store/constants';
import { COMMENTS_COLUMN_VIEW_MIN_WIDTH } from '../../../../../../const';
import {
    AsidePanelCommentsColumnViewButtonHOC
} from '../../hocs/AsidePanelCommentsColumnViewButtonHOC/AsidePanelCommentsColumnViewButtonHOC';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`AsidePanelHeader`) : null;

export function AsidePanelHeader ({
    activeTabIndex,
    isFakeLoading,
    isLoading,
    tabs,
    title,
    titleAction,
    isForceClosed,
    onClose,
    onTabChange,
    isAssignedToMe,
    isAssignedToMeWork,
    isCardFromNotification,
}: IAsidePanelHeaderProps) {
    if (analyzeRender) analyzeRender.call(activeTabIndex);
    const className = CLASS_ASIDE_PANEL_HEADER;
    const classNameLoading = isLoading ? className + '--loading' : '';
    const classNameFakeLoading = isFakeLoading ? className + '--fake-loading' : '';
    const classNameLoader = className + '-loader';
    const { boardId, cardId } = React.useContext(AsidePanelContext);

    const [isShowCommentsColumn, setShowCommentsColumn] = React.useState(null);
    React.useEffect(() => {
        if (!cardId) return;
        const onResize = () => setShowCommentsColumn(root._innerWidth > COMMENTS_COLUMN_VIEW_MIN_WIDTH);
        onResize();
        root.addEventListener('resize', onResize);
        return () => {
            root.removeEventListener('resize', onResize);
        }
    }, []);

    return (
        <div className={`
            ${className}
            ${classNameLoading}
            ${classNameFakeLoading}
            ${isShowCommentsColumn ? className + '--w-ccv' : ''}
        `}>
            {tabs
                ? <AsidePanelTabsHOC
                    activeTabIndex={activeTabIndex}
                    tabs={tabs}
                    onTabChange={onTabChange}
                />
                : <>
                    <AsidePanelTitle title={title} />
                    {!!titleAction &&
                        <AsidePanelTitleAction titleAction={titleAction} />
                    }
                </>
            }
            {!isLoading && !!tabs && !!tabs[activeTabIndex] && !!tabs[activeTabIndex].button &&
                tabs[activeTabIndex].button
            }
            {(!!isAssignedToMe || !!isCardFromNotification || isAssignedToMeWork) &&
                <AsidePanelClButtonHOC
                    cardId={cardId}
                />
            }
            {isShowCommentsColumn && <AsidePanelCommentsColumnViewButtonHOC boardId={boardId} />}
            <AsidePanelCloseHOC
                boardId={boardId}
                isForceClosed={isForceClosed}
                onClose={onClose}
            />
            <Loader className={classNameLoader} />
        </div>
    );
};
